import { render, staticRenderFns } from "./rewardEggEdit_bak.vue?vue&type=template&id=55b37e4b&scoped=true&"
import script from "./rewardEggEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardEggEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b37e4b",
  null
  
)

export default component.exports